import { render, staticRenderFns } from "./ViewHolder.vue?vue&type=template&id=0dee5016&scoped=true"
import script from "./ViewHolder.vue?vue&type=script&lang=ts"
export * from "./ViewHolder.vue?vue&type=script&lang=ts"
import style0 from "./ViewHolder.vue?vue&type=style&index=0&id=0dee5016&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dee5016",
  null
  
)

export default component.exports